export default __webpack_public_path__ + "static/moon-ed7eabc0725efe22a5027ca249a1acff.png";